if (!customElements.get("swiper-slider")) {
  function loadSwiperAssets() {
    const loaderElement = document.querySelector("[data-swiper-script]");
    if (!loaderElement) return;
  
    const swiperCSSURL = loaderElement.dataset.swiperCss;
    if (swiperCSSURL && !document.querySelector(`link[href="${swiperCSSURL}"]`)) {
      const swiperCSS = document.createElement("link");
      swiperCSS.rel = "stylesheet";
      swiperCSS.href = swiperCSSURL;
      document.head.prepend(swiperCSS);
    }
  
    const swiperScriptURL = loaderElement.dataset.swiperScript;
    if (!swiperScriptURL) return;
    if (document.querySelector(`script[src="${swiperScriptURL}"]`)) return;
  
    const swiperScript = document.createElement("script");
    swiperScript.src = swiperScriptURL;
    swiperScript.async = true;
    swiperScript.onload = declareSwiperCustomElement;
    document.head.appendChild(swiperScript);
  }
  
  if (Shopify.designMode) {
    /** In the theme editor, always load Swiper so dynamically added sections work */
    loadSwiperAssets();
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      if (document.querySelector("swiper-slider")) {
        loadSwiperAssets();
      }
    });
  }

  function declareSwiperCustomElement() {
  
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
        this.slides = this.querySelectorAll("[data-swiper-slide]");
        this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
        this.activeIndex = 0;
        this.initialized = false;
        this.resizeBound = false;
        this._idleId = null;
        this._timeoutId = null;
        if (this.dataset.swiperThumbs) {
          this.thumbnails = this.querySelector('[data-swiper-thumbs]');
        }
        this.boundInitializeSwiper = this.initializeSwiper.bind(this);
      }

      connectedCallback() {
          // Defer initialization to improve INP performance
          if ('requestIdleCallback' in window) {
            this._idleId = requestIdleCallback(() => {
              this._idleId = null;
              this.init();
            });
          } else {
            this._timeoutId = setTimeout(() => {
              this._timeoutId = null;
              this.init();
            }, 1);
          }
      }

      init() {
          if (this.dataset.customEvent) {
            this.attachCustomListeners(this.dataset.customEvent);
          }
          this.slides = this.querySelectorAll("[data-swiper-slide]");
          const allowEmptySlides = this.hasAttribute("data-swiper-allow-empty");
          if (this.slideContainer && (this.slides.length > 0 || allowEmptySlides)) {
            this.initializeSwiper()
          } else {
            console.warn("SwiperSlider - Slider or Slides Not Found");
          }
      }

      attachCustomListeners(customEvent) {
        switch (customEvent) {
          case "reinitialize":
            this.addEventListener('reinitialize-swiper', this.boundInitializeSwiper);
            break;
        }
      }
      
      disconnectedCallback() {
        if (this._idleId !== null && 'cancelIdleCallback' in window) {
          cancelIdleCallback(this._idleId);
          this._idleId = null;
        }
        if (this._timeoutId !== null) {
          clearTimeout(this._timeoutId);
          this._timeoutId = null;
        }
        if (this.debouncedResize) {
          window.removeEventListener("resize", this.debouncedResize);
        }
        if (this.slider) {
          this.slider.destroy(true, true);
          this.slider = null;
        }
        this.initialized = false;
        this.resizeBound = false;
        if (this.dataset.customEvent) {
          switch (this.dataset.customEvent) {
            case "reinitialize":
              this.removeEventListener('reinitialize-swiper', this.boundInitializeSwiper);
              break;
          }
        }
      }

      applyDefaultOptions(options) {

        if (options.loop === undefined) {
          options.loop = true;
        }
        if (options.speed === undefined) {
          options.speed = 400;
        }
        return options;
      }

      getSliderOptions() {
        try {
          return JSON.parse(this.dataset.swiperOptions);
        } catch (err) {
          console.log(err);
          return {};
        }
      }

      initializeSwiper() {
        if (window.Swiper && !this.initialized) {
          this.initialized = true;
          if(this.thumbnails) {
            this.setThumbnails()
          }
          this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        } else if (!window.Swiper) {
          console.warn("SwiperSlider - Swiper.js not found");
        }
        this.bindResizeEvent();
      }

      bindResizeEvent() {
        if (!this.resizeBound) {
          this.debouncedResize = this.debounce(() => {
            if (this.slider) {
              this.slider.updateSize();
            }
          }, 300);
          window.addEventListener("resize", this.debouncedResize);
          this.resizeBound = true;
        }
      }

      debounce(func, delay) {
        let timeoutId;
        return function () {
          const context = this;
          const args = arguments;
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(context, args);
          }, delay);
        };
      }

      setThumbnails() {
        const thumbsSlideContainer = this.thumbnails;
        const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
        const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
        this.sliderOptions.thumbs = {swiper: thumbnailsSlider};
        this.sliderOptions.on = {
          slideChange: function () {
            let activeIndex = this.activeIndex;
            document.dispatchEvent(new CustomEvent('thumbnail-changed', {
              detail: {
                slide: this.slides[this.activeIndex]
              }
            }))
            this.thumbs.swiper.slideTo(activeIndex > 0 ? activeIndex - 1 : 0);    
          }
        }
      }
    }
    customElements.define("swiper-slider", SwiperSlider);
  }
}
